module.exports = __webpack_public_path__ + "img/215-unit.265f6a58.png";